import { apiClient } from '@/api/client'
import { ORGANIZATIONS } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type {
  CurrentOrganization,
  UpdateOrganizationPayload,
} from '@/types/organization.types'

export interface OrganizationContact {
  name: string
  contactEmail: string | null
}

/** Who to ask for access (GET /organizations/current/contact); open to every member. */
export async function getOrganizationContact(): Promise<OrganizationContact> {
  const { data } = await apiClient.get<ApiResponseWrapper<OrganizationContact>>(
    ORGANIZATIONS.CURRENT_CONTACT
  )
  return data.data
}

export async function getCurrentOrganization(): Promise<CurrentOrganization> {
  const { data } = await apiClient.get<ApiResponseWrapper<CurrentOrganization>>(
    ORGANIZATIONS.CURRENT
  )
  return data.data
}

/**
 * Updates the current organization (PUT /organizations/current).
 * Only provided fields are updated; requires settings:update permission on backend.
 */
export async function updateCurrentOrganization(
  payload: UpdateOrganizationPayload
): Promise<CurrentOrganization> {
  const { data } = await apiClient.put<ApiResponseWrapper<CurrentOrganization>>(
    ORGANIZATIONS.CURRENT,
    payload
  )
  return data.data
}

/** Uploads the organization logo (POST /organizations/current/logo). */
export async function uploadOrganizationLogo(file: File): Promise<CurrentOrganization> {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await apiClient.post<ApiResponseWrapper<CurrentOrganization>>(
    ORGANIZATIONS.CURRENT_LOGO,
    formData
  )
  return data.data
}

/** Removes the organization logo (DELETE /organizations/current/logo). */
export async function deleteOrganizationLogo(): Promise<CurrentOrganization> {
  const { data } = await apiClient.delete<ApiResponseWrapper<CurrentOrganization>>(
    ORGANIZATIONS.CURRENT_LOGO
  )
  return data.data
}
